import React, {useRef} from 'react';
import styled from "styled-components";
import Container from "../../../shared/ui/container/Container";
import {Search} from "../../../features/productSearch";
import {GLOBAL_STYLE_CONFIG} from "../../../app/styles/GlobalStyles";

const StyledHeader = styled.div`
    padding: 40px 0 25px 0;
    background: ${props => props.theme.colors.background};
    z-index: 9;
    position: sticky;
    top: 0;

    .${GLOBAL_STYLE_CONFIG.splitByPrefix('search')} {
        width: 920px;
        max-width: 100%;
    }
`

const StyledGrid = styled.div`
    display: flex;
    justify-content: center;
`

const IFurnHeaderWidget = () => {
    const ref = useRef<HTMLDivElement>(null);

    return (
        <StyledHeader className={`${GLOBAL_STYLE_CONFIG.splitByPrefix('header')}`}>
            <Container>
                <StyledGrid>
                    <Search ref={ref}/>
                </StyledGrid>
            </Container>
        </StyledHeader>
    );
};

export default IFurnHeaderWidget;